/* WhatsApp Live Chat Widget for infant.ro
 * Vanilla JS, Shadow DOM, no deps.
 * Versioned in dashboard/shopify-theme-snippets/whatsapp-chat-widget/
 */
(function () {
  "use strict";

  if (location.protocol !== "https:" && location.hostname !== "localhost") return;

  const root = document.getElementById("iws-root");
  if (!root) return;

  const API_BASE = root.dataset.apiBase;
  const FALLBACK_PHONE = root.dataset.fallbackPhone || "40732976854";
  const USER_KEY = "iws_user_v1";
  const SEEN_KEY = "iws_seen_v1";

  function init() {
    let shadow;
    try {
      shadow = root.attachShadow({ mode: "open" });
    } catch (e) {
      console.warn("iws-widget: shadow DOM unsupported; aborting", e);
      return;
    }

    const css = document.querySelector('link[href*="iws-widget.css"]');
    if (css) shadow.appendChild(css.cloneNode());

    const fab = createFab();
    const panel = createPanel(shadow);
    shadow.appendChild(fab);
    shadow.appendChild(panel);

    fab.addEventListener("click", () => {
      panel.style.display = "flex";
      fab.style.display = "none";
      localStorage.setItem(SEEN_KEY, "1");
      ensureFaqsLoaded(shadow);
    });
    panel.querySelector(".iws-close").addEventListener("click", () => {
      panel.style.display = "none";
      fab.style.display = "flex";
    });
    panel.querySelector(".iws-send").addEventListener("click", () => onSendClicked(shadow));
    panel.querySelector(".iws-input-row input").addEventListener("keydown", (e) => {
      if (e.key === "Enter") onSendClicked(shadow);
    });

    if (!localStorage.getItem(SEEN_KEY)) fab.classList.add("iws-pulse");
  }

  function createFab() {
    const btn = document.createElement("button");
    btn.className = "iws-fab";
    btn.setAttribute("aria-label", "Discută cu noi pe WhatsApp");
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="white"><path d="M20.52 3.48A11.94 11.94 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.18 1.6 6L0 24l6.18-1.62A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52z"/></svg>';
    return btn;
  }

  function createPanel(shadow) {
    const panel = document.createElement("div");
    panel.className = "iws-panel";
    panel.setAttribute("role", "dialog");
    panel.style.display = "none";
    panel.innerHTML = `
      <div class="iws-header">
        <h3>Discută cu noi pe WhatsApp</h3>
        <button class="iws-close" aria-label="Închide">&times;</button>
      </div>
      <div class="iws-body">
        <p class="iws-greeting">👋 Salut! Cum te putem ajuta?</p>
        <div class="iws-input-row">
          <input type="text" placeholder="Scrie un mesaj…" />
          <button class="iws-send" aria-label="Trimite">&#10148;</button>
        </div>
        <div class="iws-section-label">Răspunsuri instantanee</div>
        <ul class="iws-faq-list" data-state="loading">
          <li class="iws-faq-item" style="color: #999;">Se încarcă…</li>
        </ul>
      </div>
    `;
    return panel;
  }

  function ensureFaqsLoaded(shadow) {
    const list = shadow.querySelector(".iws-faq-list");
    if (list.dataset.state === "loaded") return;
    // No localStorage cache — the API already serves Cache-Control: max-age=300
    // (5 min HTTP cache via Cloudflare). Avoiding localStorage means edits in the
    // dashboard appear within 5 min for everyone, no stale-cache surprises.
    fetch(`${API_BASE}/faqs`, { credentials: "omit" })
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((data) => renderFaqs(shadow, data.faqs || []))
      .catch((err) => {
        console.warn("iws-widget: faq fetch failed", err);
        list.innerHTML = "";
        list.dataset.state = "error";
      });
  }

  function renderFaqs(shadow, faqs) {
    const list = shadow.querySelector(".iws-faq-list");
    list.innerHTML = "";
    list.dataset.state = "loaded";
    if (!faqs.length) {
      list.style.display = "none";
      return;
    }
    faqs.forEach((f) => {
      const li = document.createElement("li");
      li.className = "iws-faq-item";
      li.textContent = f.question;
      li.addEventListener("click", () => showFaqAnswer(shadow, f));
      list.appendChild(li);
    });
  }

  function showFaqAnswer(shadow, faq) {
    const body = shadow.querySelector(".iws-body");
    body.innerHTML = `
      <p class="iws-section-label">${escapeHtml(faq.question)}</p>
      <p style="white-space: pre-wrap;">${escapeHtml(faq.answer)}</p>
      <div style="margin-top: 16px; display: flex; gap: 8px;">
        <button class="iws-cta-back" style="background: #eee; color: #333; border: none; border-radius: 8px; padding: 8px 12px; cursor: pointer;">← Înapoi</button>
        <button class="iws-cta-talk" style="background: var(--iws-green); color: white; border: none; border-radius: 8px; padding: 8px 12px; cursor: pointer;">💬 Vorbește cu un operator</button>
      </div>
    `;
    body.querySelector(".iws-cta-back").addEventListener("click", () => {
      const panel = shadow.querySelector(".iws-panel");
      panel.remove();
      const fresh = createPanel(shadow);
      shadow.appendChild(fresh);
      fresh.style.display = "flex";
      fresh.querySelector(".iws-close").addEventListener("click", () => {
        fresh.style.display = "none";
        shadow.querySelector(".iws-fab").style.display = "flex";
      });
      fresh.querySelector(".iws-send").addEventListener("click", () => onSendClicked(shadow));
      ensureFaqsLoaded(shadow);
    });
    body.querySelector(".iws-cta-talk").addEventListener("click", () => showFreeForm(shadow, ""));
  }

  function onSendClicked(shadow) {
    const input = shadow.querySelector(".iws-input-row input");
    const msg = input.value.trim();
    if (!msg) return;
    showFreeForm(shadow, msg);
  }

  function showFreeForm(shadow, prefillMessage) {
    const saved = readUser();
    const body = shadow.querySelector(".iws-body");
    body.innerHTML = `
      <p class="iws-section-label">Trimite-ne mesajul tău</p>
      <form class="iws-form">
        <input name="name" type="text" placeholder="Numele tău" value="${escapeHtml(saved.name || "")}" required maxlength="100" />
        <input name="phone" type="tel" placeholder="+40 7XX XXX XXX" value="${escapeHtml(saved.phone || "")}" required maxlength="32" />
        <input name="order_number" type="text" placeholder="Nr. comandă (opțional, ex: 7292)" maxlength="64" inputmode="text" autocomplete="off" />
        <textarea name="message" placeholder="Mesajul tău" rows="4" required maxlength="1000">${escapeHtml(prefillMessage)}</textarea>
        <div class="iws-error" style="display:none;"></div>
        <button type="submit">Trimite pe WhatsApp →</button>
      </form>
    `;
    const form = body.querySelector(".iws-form");
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submitForm(shadow, form);
    });
  }

  async function submitForm(shadow, form) {
    const data = new FormData(form);
    const orderRaw = (data.get("order_number") || "").toString().trim();
    const payload = {
      name: data.get("name").trim(),
      phone: data.get("phone").trim(),
      message: data.get("message").trim(),
      page_url: location.href,
      ...(orderRaw ? { order_number: orderRaw } : {}),
    };
    const errorEl = form.querySelector(".iws-error");
    const button = form.querySelector("button");
    errorEl.style.display = "none";
    button.disabled = true;
    button.textContent = "Se trimite…";
    try {
      const ctrl = new AbortController();
      const timeout = setTimeout(() => ctrl.abort(), 5000);
      const r = await fetch(`${API_BASE}/chat/initiate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: ctrl.signal,
      });
      clearTimeout(timeout);
      const json = await r.json();
      if (r.ok && json.success) {
        writeUser({ name: payload.name, phone: payload.phone });
        showSuccess(shadow, json.wa_link);
      } else if (json && json.detail && json.detail.wa_link) {
        showSuccess(shadow, json.detail.wa_link, json.detail.error);
      } else {
        throw new Error("send failed");
      }
    } catch (err) {
      console.warn("iws-widget: submit failed", err);
      const fallbackLink = `https://wa.me/${FALLBACK_PHONE}?text=${encodeURIComponent(`Bună, sunt ${payload.name}. ${payload.message}`)}`;
      showSuccess(shadow, fallbackLink, "Nu am putut anunța operatorul — folosește WhatsApp direct.");
    }
  }

  function showSuccess(shadow, waLink, warning) {
    const body = shadow.querySelector(".iws-body");
    if (warning) {
      // Backend partial fail — show the warning + raw fallback button
      body.innerHTML = `
        <div class="iws-success">
          <div class="iws-success-icon">✅</div>
          <p><strong>Mesaj înregistrat!</strong></p>
          <p>${escapeHtml(warning)}</p>
          <a class="iws-cta" href="${waLink}" target="_blank" rel="noopener">Deschide WhatsApp →</a>
        </div>
      `;
      return;
    }
    body.innerHTML = `
      <div class="iws-success">
        <div class="iws-success-icon">✅</div>
        <p><strong>Operatorul a primit mesajul!</strong></p>
        <p style="margin-bottom: 6px;">
          Mesajul tău a ajuns deja la noi în inbox.
        </p>
        <p style="font-size: 13px; color: #444; margin-top: 0;">
          🔓 <strong>Un singur pas pentru a primi răspunsul:</strong>
          apasă mai jos, apoi <strong>trimite mesajul pre-completat</strong>
          în WhatsApp. Așa deschidem canalul ca să-ți putem răspunde direct.
        </p>
        <a class="iws-cta" href="${waLink}" target="_blank" rel="noopener">
          Deschide WhatsApp și trimite →
        </a>
      </div>
    `;
  }

  // Clean up legacy localStorage cache from previous widget version (had 1h TTL
  // which caused stale FAQ surprises). Safe to remove on every page load.
  try { localStorage.removeItem("iws_faq_cache_v1"); } catch {}

  function readUser() {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || "{}"); }
    catch { return {}; }
  }
  function writeUser(u) {
    try { localStorage.setItem(USER_KEY, JSON.stringify(u)); } catch {}
  }
  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
    }[c]));
  }

  if ("requestIdleCallback" in window) {
    requestIdleCallback(init, { timeout: 2000 });
  } else {
    setTimeout(init, 1500);
  }
})();
